import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { LangContext } from "./App";

const MetaTags = () => {
  const [lang] = useContext(LangContext);
  const meta = {
    title:{
        fr: "A Minecraft Movie Meal et ses super figurines à collectionner. ",
        de: "A Minecraft Movie Meal ist da – inklusive coolen Sammelfiguren. ",
        it: "È arrivato A Minecraft Movie Meal con personaggi da collezionare. ",
      },
      description:{
        fr:"McDonald’s x Minecraft : retrouve dans chaque Menu Medium l’une des 6 figurines exclusives à collectionner, plus un skin. Clique pour en savoir plus. ",
        de: "McDonald’s trifft auf Minecraft: Mit jedem Menu Medium gibt’s eine von 6 exklusiven Sammelfiguren plus In-Game-Skin. Jetzt Klicken und mehr erfahren. ",
        it: "McDonald’s incontra Minecraft: ogni Menu Medium include uno dei 6 esclusivi personaggi da collezione più in-game skin. Clicca ora per saperne di più. ",
    },
  };

  const title = meta.title[lang] || meta.title.de;
  const description = meta.description[lang] || meta.description.de;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="og:title" content={title} />
      <meta name="og:description" content={description} />
    </Helmet>
  );
};

export default MetaTags;
